import { transparentize } from 'polished';
import * as React from 'react';
import { InputHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../easyclaim.app.theme/theme';
import { FadeIn } from '../animations/FadeIn';

import { Circle } from './Circle';
import { StyledIconCheck } from './CommonStyles';

interface TextAreaProps extends InputHTMLAttributes<HTMLTextAreaElement> {
	isValid?: boolean;
	maxLength?: number;
	value: string | number | string[] | undefined;
	textLengthCounterClassName?: string;
	className?: string;
}

export class TextArea extends React.Component<TextAreaProps, {}> {
	render() {
		const { isValid, ...props } = { ...this.props };

		return (
			<>
				<Container className={`TextArea-Container`}>
					<StyledTextArea
						className="TextArea-Container-Text"
						{...props}
						maxLength={this.props.maxLength}
						value={this.props.value}
					/>
					{this.props.isValid && (
						<BottomCircle
							className="TextArea-Container-BottomCircle"
							borderColor={theme.colors.success}
							borderWidth="1px"
							borderStyle="solid"
						>
							<StyledIconCheck color={theme.colors.success} />
						</BottomCircle>
					)}
				</Container>
				{!!this.props.maxLength && (
					<TextLength className={this.props.textLengthCounterClassName}>
						{(this.props.value as string).length}/{this.props.maxLength}
					</TextLength>
				)}
			</>
		);
	}
}

const Container = styled.div`
	position: relative;
	margin-bottom: 1rem;
	display: flex;
	flex-grow: 1;
	flex-shrink: 1;
`;

const TextLength = styled.span`
	display: block;
	text-align: right;
`;

const StyledTextArea = styled.textarea`
	display: block;
	background-color: ${(p) => transparentize(0.7, p.theme.colors.secondary)};
	padding: 0.7rem 0.7rem;
	border-radius: 3px;
	width: calc(100% - 1.4rem);
	min-height: 8rem;
	resize: none;
	flex-grow: 1;
	font-size: inherit;
	font-family: inherit;
	line-height: inherit;
	&::placeholder {
		color: ${(p) => transparentize(0.45, '#000')};
		opacity: 1;
	}
`;

const BottomCircle = styled(Circle)`
	position: absolute;
	height: 2rem;
	bottom: 0.7rem;
	right: 1rem;
	animation: ${css`
			${FadeIn}`} 0.3s ease-in forwards;
`;
